<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTagGroup from "@/components/YTTagGroup/index.vue"
import YTItemState from "@/components/YTItemState/index.vue"
import YTCheckPanel from "@/components/YTCheckedPanel/index.vue"
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {changeOnlineStoreGoodsState, listOnlineStoreGoodsList} from "@/api/goods/goods.js";
import {listOnlineStoreGoodsGroup} from "@/api/storeGroup/storeGroup.js";
import {setOnlineStoreGoodsGroup} from "@/api/goodsStoreGroup/goodsStoreGroup.js";

// 多选框打开状态
const open = ref(false);

/*初次加载*/
onMounted(async () => {
  await handleGetGroupList()
  await handleSearch()
})

// 分组数据
const groupList = ref([])

/*搜索功能*/
// 表单数据
const formData = reactive({
  goodsName: null,
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listOnlineStoreGoodsList(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    console.log("res", res)
    loading.value = false
  } catch (e) {
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.goodsName = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '商品名称', key: 'goodsName', minWidth: "150px", nowrap: true },
  { title: '成本价格', key: 'costPrice', minWidth: "150px", nowrap: true },
  { title: '零售价格', key: 'retailPrice', minWidth: "150px", nowrap: true },
  { title: '分组', key: 'storeGroupList', maxWidth: "340px", minWidth: "280px", nowrap: true },
  { title: '状态', key: 'state', minWidth: "100px", nowrap: true },
  { title: '操作', key: 'controls', minWidth: "100px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}
// 获取分组列表
const handleGetGroupList = async () =>  {
  const res = await listOnlineStoreGoodsGroup()
  groupList.value = []
  res.forEach((item) => {
    const param = {
      name: item.storeGroupName,
      value: item.storeGroupId
    }
    groupList.value.push(param)
  })
}

/*操作栏功能*/
// 上架
const setSale = async (item) => {
  const param = {
    ...item,
    state: 1
  }
  try {
    await changeOnlineStoreGoodsState(param)
    ElMessage.success("上架成功")
    await handleSearch()
  } catch (e) {
    console.log(e)
  }
}
// 下架
const setUnSale = async (item) => {
  const param = {
    ...item,
    state: 0
  }
  try {
    await changeOnlineStoreGoodsState(param)
    ElMessage.success("下架成功")
    await handleSearch()
  } catch (e) {
    console.log(e)
  }
}
// 分组缓存信息
const cacheItem = ref()
// 分组
const setGroup = (item) => {
  cacheItem.value = item
  open.value = true
}

/*分组弹窗*/
// 确认选择分组
const handlePanelConfirm = async (item) => {
  console.log("分组弹窗传回内容:", item)
  const param = {
    goodsId: cacheItem.value.goodsId,
    storeGroupIdList: item
  }
  try {
    await setOnlineStoreGoodsGroup(param)
    await handleSearch()
    ElMessage.success("修改分组成功")
  } catch (e) {
    console.log(e)
  }
  open.value = false
}
// 取消选择分组
const handlePanelClose = () => {
  cacheItem.value = null
  open.value = false
}
</script>

<template>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="4">
                    <v-text-field
                        v-model="formData.goodsName"
                        placeholder="请输入商品名称"
                        label="商品名称"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" offset="5">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('all', 'onlineStoreGoods:view')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'onlineStoreGoods:view')">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.storeGroupList="{ item, index }">
            <YTTagGroup :list="item.storeGroupList.map(res => res.storeGroupName)"></YTTagGroup>
          </template>

          <template v-slot:item.state="{ item }">
            <YTItemState :state="item.state"></YTItemState>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-popconfirm @confirm="setSale(item)" :title="`上架“${item.goodsName}”`">
                <template #reference>
                  <div>
                    <el-tooltip
                        v-if="item.state === 0"
                        class="box-item"
                        effect="dark"
                        content="上架"
                        placement="left">
                      <v-icon class="cursor-pointer" icon="mdi-tray-arrow-up" color="success" v-show="$handleHasBtnPermission('all', 'onlineStoreGoodsState:edit')"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <el-popconfirm @confirm="setUnSale(item)" :title="`下架“${item.goodsName}”`">
                <template #reference>
                  <div>
                    <el-tooltip
                        v-if="item.state === 1"
                        class="box-item"
                        effect="dark"
                        content="下架"
                        placement="left">
                      <v-icon class="cursor-pointer" icon="mdi-tray-arrow-down" color="error" v-show="$handleHasBtnPermission('all', 'onlineStoreGoodsState:edit')"></v-icon>
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="分组"
                  placement="right">
                <v-icon class="mg_l_1" icon="mdi-tag-outline" color="warning" @click="setGroup(item)"  v-show="$handleHasBtnPermission('all', 'onlineStoreGroup:edit')"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
  <YTCheckPanel
      v-if="open"
      :open="open"
      :title="cacheItem.goodsName"
      :checkedList="cacheItem.storeGroupList.map(res => res.storeGroupId)"
      :list="groupList"
      :hasAll="false"
      :checkedLimit="2"
      @cancel="handlePanelClose"
      @confirm="handlePanelConfirm"
  ></YTCheckPanel>
</template>

<style scoped>

</style>